import {
  AutoStories as NovelIcon,
} from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserNovels } from '@/context/user-novels-context';

interface NovelImportDialogProps {
  open: boolean;
  onClose: () => void;
  onImport: (novelId: string) => void;
}

export function NovelImportDialog({ open, onClose, onImport }: NovelImportDialogProps) {
  const { t } = useTranslation();
  const { ownedNovels, isLoading } = useUserNovels();

  const novels = useMemo(() => {
    return [...ownedNovels]
      .map(n => ({ id: n.id, title: n.title || t('entity_settings.untitled') }))
      .sort((a, b) => a.title.localeCompare(b.title));
  }, [ownedNovels, t]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ variant: 'h6', fontSize: '1.25rem' }}>
        {t('entity_settings.import_schema')}
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        {isLoading ? (
          <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}><CircularProgress size={24} /></Box>
        ) : (
          <List sx={{ pt: 0 }}>
            {novels.map((novel) => (
              <ListItem key={novel.id} component="div" dense>
                <Button
                  fullWidth
                  onClick={() => onImport(novel.id)}
                  sx={{ justifyContent: 'flex-start', color: 'text.primary', py: 1 }}
                  startIcon={<NovelIcon sx={{ opacity: 0.5 }} />}
                >
                  {novel.title}
                </Button>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="small">{t('common.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
}
